import { combineReducers } from 'redux'
import NewsAllReducer from './news.all.reducer'
import NewsItemReducer from './news.item.reducer'

const NewsReducer = combineReducers({
  all: NewsAllReducer,
  item: NewsItemReducer,
})

export default NewsReducer